import React from 'react';
import {FaMapMarkerAlt, FaPhone, FaEnvelope, FaWhatsapp } from 'react-icons/fa'; // Import des icônes
import banner from '../assets/images/banner.jpg'; // Import de l'image de l'équipe

const Contact = () => {
  return (
    <div className="container my-5">
      <h1>Contactez-nous</h1>

      {/* Section Adresses et Image de l'équipe */}
      <div className="row align-items-center mb-4">
        {/* Colonne pour les adresses et contacts */}
        <div className="col-md-6">
          <h3>Adresses</h3>
          <p>
            <FaMapMarkerAlt className="me-2 text-primary" /> {/* Icône d'adresse */}
            <strong>Cameroun :</strong>  BONEPOUPA dans le Département du NKAM - 45KM de DOUALA
          </p>
        
          <h3 className="mt-4">Contacts</h3>
          <p>
            <FaPhone className="me-2 text-success" /> {/* Icône de téléphone */}
            <strong>Cameroun :</strong> +237 678476043
          </p>
          
          <p>
            <FaEnvelope className="me-2 text-danger" /> {/* Icône d'email */}
            <strong>Email :</strong> hello@kamadeu.com
          </p>
        </div>

        {/* Colonne pour l'image de l'équipe */}
        <div className="col-md-6 text-center">
          <img
            src={banner} // Image de l'équipe
            alt="Notre équipe"
            className="img-fluid rounded"
            style={{ maxWidth: '100%', height: 'auto' }}
          />
        </div>
      </div>

      {/* Section Boutons de contact */}
      <div className="mb-4">
        <h3>Nous contacter</h3>
        <div className="d-flex gap-3">
          {/* Bouton WhatsApp */}
          <a
            href="https://wa.me/237678476043"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-success"
          >
            <FaWhatsapp className="me-2" /> {/* Icône WhatsApp */}
            Contactez-nous par WhatsApp
          </a>

          {/* Bouton Email */}
          <a
            href="mailto:hello@kamadeu.com"
            className="btn btn-primary"
          >
            <FaEnvelope className="me-2" /> {/* Icône Email */}
            Contactez-nous par mail
          </a>
        </div>
      </div>
    </div>
  );
};

export default Contact;